import { useEffect, useState } from "react";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { PLAN_LABELS } from "../../../constants/automapDealerPlanConstants";
import { fetchPlanFeatures } from "../../../services/automapDealerPlanApi";
import { AdminPlansNav, PlanFeatureCell } from "./AdminPlansShared";

export default function AdminPlanFeaturesPage() {
  const [matrix, setMatrix] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchPlanFeatures()
      .then((data) => setMatrix(data.matrix))
      .catch((err) => setError(err.message || "Error"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Planes" title="Matriz de features" description="Configuración centralizada (solo lectura). TODO: editor admin." />
      <AdminAutomotiveNav active="plans" />
      <AdminPlansNav active="features" />
      <main className="admin-console__main wrap">
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading && matrix ? (
          <>
            <p className="muted">{matrix.note}</p>
            <div className="import-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Feature</th>
                    {(matrix.plans || []).map((p) => (
                      <th key={p.planKey}>{PLAN_LABELS[p.planKey] || p.publicName}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["listingLimit", "Límite listings"],
                    ["leadLimitMonthly", "Límite leads/mes"],
                    ["bulkUploadAccess", "Carga masiva"],
                    ["publicDealerProfileEnabled", "Perfil público"],
                    ["verificationBadgeEligible", "Badge verificación"],
                    ["performanceReportsAccess", "Reportes"],
                    ["campaignReportingAccess", "Reportes campaña"],
                    ["featuredPlacementEligible", "Placement destacado"],
                    ["prioritySupport", "Soporte prioritario"],
                    ["seoDealerPageEligible", "SEO dealer"],
                  ].map(([key, label]) => (
                    <tr key={key}>
                      <td>{label}</td>
                      {(matrix.plans || []).map((p) => (
                        <td key={p.planKey}><PlanFeatureCell value={p[key]} /></td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
